import React from "react";
import "./SectionTitle.scss";

const SectionTitle = ({ title, subtitle, actions, className = "" }) => {
    if (!title && !actions) {
        return null;
    }

    return (
        <div className={`section-title ${className}`}>
            <div className="section-title__content">
                {(title || subtitle) && (
                    <div className="section-title__text">
                        {title && (
                            <h2 className="section-title__title">{title}</h2>
                        )}
                        {subtitle && (
                            <p className="section-title__subtitle">
                                {subtitle}
                            </p>
                        )}
                    </div>
                )}

                {actions && (
                    <div className="section-title__actions">
                        {Array.isArray(actions)
                            ? actions.map((action, index) => (
                                  <React.Fragment key={index}>
                                      {action}
                                  </React.Fragment>
                              ))
                            : actions}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SectionTitle;
